import React from 'react';
import Address from './Address';

function AddressBookList({
  addressBookData = [],
  type,
  selectAny,
  handleAddressSelect,
  editPopup,
  setEditPopup,
}) {
  return (
    <div>
      <div id="addressbookListBlock" className="addressBodyLeft">
        <div
          className="bodyLeftAdd"
          onClick={() => setEditPopup({ open: true, referringMasterId: '' })}
        >
          <h3 className="cursor">
            {type === 2 && '+ Add New Provider'}
            {type === 3 && '+ Add New Facility'}
            {type === 4 && '+ Add New Insurance'}
            {type === 5 && '+ Add New Recipient'}
          </h3>
        </div>
        <div className="bodyLeftContainer">
          {addressBookData.length > 0 &&
            addressBookData.map((val) => (
              <Address
                key={val.id}
                data={val}
                handleAddressSelect={handleAddressSelect}
                editPopup={editPopup}
                setEditPopup={setEditPopup}
              />
            ))}
        </div>
      </div>
    </div>
  );
}

export default AddressBookList;
